import React from 'react';
import { get } from 'lodash';
import { FinanceResponseData } from '@upstart/harmony/lib/legos/financingTypes';
import { IntegerInputType } from '../ricFormTypes';
import { SectionNumberInputItem } from '../Components';

const SchemaIntegerInput = ({
  formElement,
  responseData,
  fetchResponseWithUpdatedData,
}: {
  formElement: IntegerInputType;
  responseData: FinanceResponseData;
  fetchResponseWithUpdatedData: (data: Partial<FinanceResponseData>) => void;
}) => {
  const { title, subtitle, responseDataField, required } = formElement;

  const value = get(responseData, responseDataField)?.toString();
  const intValue = value ? parseInt(value, 10) : undefined;

  return (
    <SectionNumberInputItem
      title={title}
      subtitle={subtitle}
      value={intValue}
      field={responseDataField}
      onChange={fetchResponseWithUpdatedData}
      required={required}
    />
  );
};

export default SchemaIntegerInput;
